<template>
  <div ref="frisbuy-widget-gallery" :class="{ 'frisbuy-widget': true, 'frisbuy-vertical': isVerticalGallery, [`frisbuy-layout-${ gallerySettings.layout }`]: gallerySettings.layout, [`frisbuy-${ settings.customerCode }`]:true}">
    <picture>
      <source media="(max-width: 640px)" :srcset="`${envDomain}/images/lassie/lassie-june-24-mob.jpg`">
      <img class="frisbuy-lassie-banner" :src="`${envDomain}/images/lassie/lassie-june-24-desk.jpg`" alt="Загрузи фотографию, отметь любимые продукты и получи приз!">
    </picture>
    <div v-if="showPromotionConditions" class="frisbuy-promotion-conditions">
      <div v-if="headerSettings.html" v-html="headerSettings.html">
      </div>
    </div>
    <div
      :class="{
        'frisbuy-promotion-conditions-btn': true,
        'frisbuy-promotion-conditions-btn-show': showPromotionConditions,
        'frisbuy-promotion-conditions-btn-hide': !showPromotionConditions,
      }"
      @click="togglePromotionConditions">
    {{ showPromotionConditionsBtnText }}
    </div>
    <div class="frisbuy-lassie-container">
      <div class="frisbuy-lassie-iu-banner">
        <div class="frisbuy-lassie-iu-banner__imgs">
          <div class="frisbuy-lassie-img frisbuy-lassie-img--left" :style="{
            'background-image': `url(${ settings.srcDomain }/sld08/files/70176/1161_asset_lassie_june_contest_1.jpg)`
          }"></div>
          <div
            class="frisbuy-lassie-img frisbuy-lassie-img--center"
            :style="{
            'background-image': `url(${ settings.srcDomain }/sld08/files/70188/1161_asset_lassie_june_contest_2.jpg)`
          }"></div>
          <div
          class="frisbuy-lassie-img frisbuy-lassie-img--right"
          :style="{
          'background-image': `url(${ settings.srcDomain }/sld08/files/70187/1161_asset_lassie_june_contest_3.jpg)`
          }"></div>
        </div>
        <div class="frisbuy-lassie-iu-banner-main">
          <div class="frisbuy-lassie-iu-banner-main__text">
            <span v-show="isContestEnded">
              Конкурс завершён.
            </span>

            <span
              v-if="headerSettings.title"
              v-html="headerSettings.title"
            ></span>
            <span v-else-if="!isContestEnded">
              Загрузи лучшие фото и пригласи всех своих друзей участвовать в онлайн-голосовании! Твой шанс выиграть подарочный промокод в магазине "Lassie" на 10 000, 5 000 и 3000 рублей!
            </span>
            <br/>
          </div>

          <button v-if="!isContestEnded" widget-iu-button="true" class="frisbuy-lassie-iu-banner__btn" @click="openIU">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.4316 6.96937L15.1838 4.99781C14.9208 4.69125 14.5603 4.5 14.1562 4.5H9.84375C9.43969 4.5 9.07922 4.69125 8.81625 4.99781L7.56844 6.96937C7.30547 7.27641 6.96656 7.5 6.5625 7.5H3.75C3.35218 7.5 2.97064 7.65804 2.68934 7.93934C2.40804 8.22064 2.25 8.60218 2.25 9V18C2.25 18.3978 2.40804 18.7794 2.68934 19.0607C2.97064 19.342 3.35218 19.5 3.75 19.5H20.25C20.6478 19.5 21.0294 19.342 21.3107 19.0607C21.592 18.7794 21.75 18.3978 21.75 18V9C21.75 8.60218 21.592 8.22064 21.3107 7.93934C21.0294 7.65804 20.6478 7.5 20.25 7.5H17.4844C17.0789 7.5 16.6945 7.27641 16.4316 6.96937Z" stroke="#42affe" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 16.5C14.0711 16.5 15.75 14.8211 15.75 12.75C15.75 10.6789 14.0711 9 12 9C9.92893 9 8.25 10.6789 8.25 12.75C8.25 14.8211 9.92893 16.5 12 16.5Z" stroke="#42affe" stroke-width="1.5" stroke-miterlimit="10"/>
              <path d="M5.8125 7.40625V6.375H4.6875V7.40625" stroke="#42affe" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Добавить фотографию</span>
          </button>
        </div>
      </div>
      <div class="frisbuy-lassie-countdown">
        <div class="frisbuy-lassie-countdown__header">До конца конкурса осталось</div>
        <div class="frisbuy-lassie-countdown-timer">
          <div >
            <div class="frisbuy-lassie-countdown-timer__time timer-text">{{countdownDateObject.days}}</div>
            <div class="frisbuy-lassie-countdown-timer__caption">дней</div>
          </div>
          <div class="frisbuy-lassie-countdown-timer__slash timer-text">/</div>
          <div>
            <div class="frisbuy-lassie-countdown-timer__time timer-text">{{countdownDateObject.hours}}</div>
            <div class="frisbuy-lassie-countdown-timer__caption">часов</div>
          </div>
          <div class="frisbuy-lassie-countdown-timer__slash timer-text">/</div>
          <div>
            <div class="frisbuy-lassie-countdown-timer__time timer-text">{{countdownDateObject.minutes}}</div>
            <div class="frisbuy-lassie-countdown-timer__caption">минут</div>
          </div>
        </div>
      </div>
    </div>
    <div class="frisbuy-lassie-gallery-top">
      <div v-if="headerSettings.subTitle" v-html="headerSettings.subTitle"></div>
      <div class="frisbuy-lassie-gallery-top__filter">
        <div @click="toggleFilterPopup()" :class="{ 'filter-show': showOrderByPopup, 'filter-hide': !showOrderByPopup,}">
          {{ orderBy.label }}
        </div>
        <div class="frisbuy-lassie-gallery-top__filter-popup" v-show="showOrderByPopup">
          <div
            v-for="option in orderByOptions"
            @click="orderPosts(option)"
            :key="option.id"
            :style="{color: orderBy.id === option.id ? '#42affe' : undefined}"
            >{{ option.label }}</div>
        </div>
      </div>
    </div>

    <FrisbuyPopupAlertConditions 
      v-if="isShowAlertConditions"
      @close="isShowAlertConditions = false"
      @confirm="alertConditionsConfirm"
    />

    <div class="frisbuy-gallery">
      <div
        :class="{ 'frisbuy-scroll-wrapper': true, 'no-scroll-width': !isVerticalGallery && scrollWidth < 0 }"
        :style="{ height: isVerticalGallery && gallerySettings.maxCols && `${ ((containerItemHeight + containerItemMargin) * gallerySettings.maxCols) }px`}"
        v-touch:swipe="swipeHandler"
        ref="postsScroll"
        >
        <div :style="{ padding: isLineRowsMode && scrollWidth < 0 && `0 ${ containerItemMargin / 2}px` }">
          <ul
            :class="{ 'frisbuy-gallery-posts': true, 'frisbuy-gallery-multiline': isLineRowsMode, [`frisbuy-scheme-${ gallerySettings.scheme }`]: gallerySettings.layout == 'tile' && gallerySettings.scheme }"
          >
            <template v-for="(post, index) in postList">
              <li v-if="gallerySettings.scheme && !isTablet && (index == 5 || !((index - 5) % 9))" class="frisbuy-divider"></li>
              <template v-if="post.frisbuyPost.type === 'advertising'"></template>
              <post-item
                v-else
                :post="post"
                :key="post.frisbuyPost.id"
                :index="index"
                ref="postImage"
                :settings="settings"
                :mobile-settings="mobileSettings"
                :observer="imageObserver"
                :isContestEnded="isContestEnded"
                @click="clickPostHandler(post, index)"
                @like-click="handleLikeClick(post.frisbuyPost.id)"
                >
              </post-item>
            </template>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="gallerySettings.branding" :class="[{'frisbuy-branding': true}, gallerySettings.branding ]">
      Сделано на
      <a :href="settings.brandingLink || ('https://www.frisbuy.ru/?utm_source=gallery&utm_medium=referral&utm_campaign='+settings.customerCode)" rel="nofollow" target="_blank">
        <img :src="`${envDomain}/images/widget/frisbuy_logo_gray.svg`" alt="Frisbuy" />
      </a>
    </div>
    <div class="frisbuy-footer frisbuy-flex-center">
      <div
        class="frisbuy-lassie-loadmore-button frisbuy-flex-center"
        @click="loadMoreHandler"
      >{{ gallerySettings.loadMore.text || 'Покажи еще образы' }}</div>
      <div v-if="gallerySettings.footer.html" v-html="gallerySettings.footer.html"></div>
    </div>
  </div>

  <Popup
    v-if="isShowPopup"
    :settings="settings"
    :mobileSettings="mobileSettings"
    :postList="postList"
    :post="currentPost"
    :postIndex="currentPostIndex"
    :isContestEnded="isContestEnded"
    @changePost="(direction) => selectPost(postList[currentPostIndex + direction], currentPostIndex + direction)"
    @close="() => closePopup()"
  />
</template>

<style scoped src="../../../gallery/gallery/gallery.scss" lang="scss"></style>

<script>
import defaultGallery from "@/gallery/gallery/gallery.vue";
import Popup from "../popup/popup.vue";
import Axios from "axios";
import Vue from "vue";
import { v4 as uuid } from "uuid";
import FrisbuyPopupAlertConditions from "../components/FrisbuyPopupAlertConditions/FrisbuyPopupAlertConditions.vue";
import { openRegistrationForm } from "../services";

export default {
  mixins: [defaultGallery],

  components: { Popup, FrisbuyPopupAlertConditions },

  data() {
    return {
      showPromotionConditions: false,
      showOrderByPopup: false,
      orderBy: {
        id: 1,
        value: undefined,
        label: "По новизне",
      },
      isShowAlertConditions: false,
      countdownDateObject: {
        days: "00",
        hours: "00",
        minutes: "00",
      },
    };
  },

  computed: {
    isLikesDisabled() {
      const isDisabled = this.settings.disable_post_like || this.isContestEnded;
      return isDisabled;
    },

    isContestEnded() {
      const endTimerDate = this.settings.contestEndTime;
      const countdownDate = new Date(endTimerDate);

      if (
        new Date().getTime() > countdownDate.getTime() ||
        countdownDate.toString() === "Invalid Date"
      ) {
        return true;
      } else {
        return false;
      }
    },

    orderByOptions() {
      return [
        {
          id: 1,
          value: undefined,
          label: "По новизне",
        },
        {
          id: 2,
          value: "like_count",
          label: "По рейтингу",
        },
      ];
    },

    showPromotionConditionsBtnText() {
      return this.showPromotionConditions ? "Свернуть" : "Подробные условия";
    },
  },

  methods: {
    isUserLoggedIn() {
      const { logged_in_id, logged_in_email, logged_in_phone } = this.settings;

      return !!logged_in_id && !!logged_in_email && !!logged_in_phone;
    },

    openIU() {
      if (!this.isUserLoggedIn()) {
        openRegistrationForm();
      } else {
        iuWidget.open();
      }
    },

    toggleFilterPopup() {
      this.showOrderByPopup = !this.showOrderByPopup;
    },

    orderPosts(orderDirectionObject) {
      this.showOrderByPopup = false;

      let url = this.settings.sourceUrl;
      if (orderDirectionObject.id !== 1) {
        url += `&order_by=${orderDirectionObject.value}`;
      }

      if (orderDirectionObject.id !== this.orderBy.id) {
        Axios.get(`${url}&data=1`).then((response) => {
          this.orderBy = orderDirectionObject;
          const { posts, lastPage } = response.data;
          this.postList.splice(0, this.postList.length, ...posts);

          this[this.isTablet ? "mobileSettings" : "settings"].gallery.loadMore.enable = !lastPage;

          if (!lastPage) {
            this.$nextTick(this.onScroll);
          }
        });
      }
    },

    togglePromotionConditions() {
      this.showPromotionConditions = !this.showPromotionConditions;
    },

    alertConditionsConfirm() {
      const blockToScrollId = "#mindbox-subscribe-form";
      const blockToScroll = document.querySelector(blockToScrollId);

      this.isShowAlertConditions = false;

      if (blockToScroll) {
        blockToScroll.scrollIntoView({ behavior: "smooth" });
      }
    },

    handleLikeClick(frisbuyPostId) {
      if (this.isLikesDisabled) {
        return;
      }

      if (!this.isUserLoggedIn()) {
        openRegistrationForm();
      } else {
        if (this.settings.logged_in_subscription !== true) {
          this.isShowAlertConditions = true;

          return;
        }

        document.cookie = `_customerWidget=${uuid()}`;
        const index = this.postList.findIndex(
          (x) => x.frisbuyPost.id == frisbuyPostId
        );
        if (this.postList[index].instagramPost.wasLiked) {
          this.postList[index].instagramPost.likeCount -= 1;
          window.likedPosts = window.likedPosts.filter(
            (postIdx) => postIdx !== index
          );
          this.postList[index].instagramPost.wasLiked = false;
        } else {
          window.likedPosts = [...window.likedPosts, index];
          this.postList[index].instagramPost.likeCount += 1;
          this.postList[index].instagramPost.wasLiked = true;
        }
        const url = `${this.settings.srcDomain}/fb/post/likes`;
        Axios.post(url, {
          embed_id: this.settings.embedId,
          username: this.settings.logged_in_username,
          frisbuy_post_id: frisbuyPostId,
          logged_in_id: this.settings.logged_in_id,
          email: this.settings.logged_in_email,
          phone: this.settings.logged_in_phone,
        });
      }
    },

    loadMoreCallback(url) {
      return this.orderBy.id === 1
        ? url
        : `${url}&order_by=${this.orderBy.value}`;
    },

    getPrettyDate(dateObject) {
      function getPrettyValue(dateParam) {
        if (Number(dateParam) > 9) {
          return dateParam.toString();
        } else {
          return `0${dateParam}`;
        }
      }

      const prettyDateObj = {
        days: getPrettyValue(dateObject.days),
        hours: getPrettyValue(dateObject.hours),
        minutes: getPrettyValue(dateObject.minutes),
      };

      return prettyDateObj;
    },

    countTime(countdownDate) {
      const HOURS_IN_DAY = 24;
      const MINUTES_IN_HOUR = 60;
      const SECONDS_IN_MINUTE = 60;
      const MILLISECONDS_IN_SECOND = 1000;

      const now = new Date().getTime();
      const distance = countdownDate - now;

      const days = Math.floor(
        distance /
          (MILLISECONDS_IN_SECOND *
            MINUTES_IN_HOUR *
            SECONDS_IN_MINUTE *
            HOURS_IN_DAY)
      );
      const hours = Math.floor(
        (distance %
          (MILLISECONDS_IN_SECOND *
            MINUTES_IN_HOUR *
            SECONDS_IN_MINUTE *
            HOURS_IN_DAY)) /
          (MILLISECONDS_IN_SECOND * MINUTES_IN_HOUR * SECONDS_IN_MINUTE)
      );
      const minutes = Math.floor(
        (distance %
          (MILLISECONDS_IN_SECOND * MINUTES_IN_HOUR * SECONDS_IN_MINUTE)) /
          (MILLISECONDS_IN_SECOND * SECONDS_IN_MINUTE)
      );

      this.countdownDateObject = this.getPrettyDate({ days, hours, minutes });
    },

    startCountdownTimer() {
      /*
        example format ISO8601
        const endTimerDate = "2004-02-13T15:19:21+00:00";
      */
      const endTimerDate = this.settings.contestEndTime;
      const countdownDate = new Date(endTimerDate);

      if (
        new Date().getTime() > countdownDate.getTime() ||
        countdownDate.toString() === "Invalid Date"
      ) {
        return;
      }

      const MILLISECONDS_IN_MINUTE = 60000;
      this.countTime(countdownDate);

      const timer = setInterval(() => {
        this.countTime(countdownDate);
        const now = new Date().getTime();
        const distance = countdownDate - now;

        if (distance < 0) {
          clearInterval(timer);
        }
      }, MILLISECONDS_IN_MINUTE);
    },
  },

  mounted() {
    this.startCountdownTimer();
    window.likedPosts = [];
  },
}
</script>